import { equalWithinTolerance } from './equalsWithinTolerance';

export const stressToleranceInPoundsPerSquareFoot = 0.05;

export function stressEquals(stressOneInPoundsPerSquareFoot: number, stressTwoInPoundsPerSquareFoot: number) {
  return equalWithinTolerance(
    stressOneInPoundsPerSquareFoot,
    stressTwoInPoundsPerSquareFoot,
    stressToleranceInPoundsPerSquareFoot,
  );
}

export function stressGreaterThanOrEqual(
  stressOneInPoundsPerSquareFoot: number,
  stressTwoInPoundsPerSquareFoot: number,
) {
  return (
    stressOneInPoundsPerSquareFoot >= stressTwoInPoundsPerSquareFoot ||
    stressEquals(stressOneInPoundsPerSquareFoot, stressTwoInPoundsPerSquareFoot)
  );
}

export function stressLessThanOrEqual(stressOneInPoundsPerSquareFoot: number, stressTwoInPoundsPerSquareFoot: number) {
  return (
    stressOneInPoundsPerSquareFoot <= stressTwoInPoundsPerSquareFoot ||
    stressEquals(stressOneInPoundsPerSquareFoot, stressTwoInPoundsPerSquareFoot)
  );
}

export function stressGreaterThan(stressOneInPoundsPerSquareFoot: number, stressTwoInPoundsPerSquareFoot: number) {
  return !stressLessThanOrEqual(stressOneInPoundsPerSquareFoot, stressTwoInPoundsPerSquareFoot);
}

export function stressLessThan(stressOneInPoundsPerSquareFoot: number, stressTwoInPoundsPerSquareFoot: number) {
  return !stressGreaterThanOrEqual(stressOneInPoundsPerSquareFoot, stressTwoInPoundsPerSquareFoot);
}
